<div class="relative flex h-screen min-w-0 flex-col overflow-hidden rounded-none bg-gray-50 shadow-xl md:h-[90vh] md:flex-row md:rounded-2xl">
  
  <aside
    [class.hidden]="!isMobileMenuOpen"
    class="absolute inset-y-0 left-0 z-50 flex w-64 flex-shrink-0 flex-col border-r bg-white transition-all md:relative md:flex md:translate-x-0"
    [ngClass]="isMobileMenuOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full md:translate-x-0'"
  >
    <div class="flex items-center justify-between border-b p-6">
      <h2 class="text-xs font-bold uppercase tracking-wider text-gray-400">Entidades Maestras</h2>
      <button mat-icon-button class="md:hidden" (click)="isMobileMenuOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="px-6 py-4">
      <div class="relative">
        <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">search</mat-icon>
        <input
          type="text"
          placeholder="Buscar entidad..."
          [formControl]="searchControl"
          class="w-full rounded-lg border-none bg-gray-100 py-2 pl-9 pr-4 text-sm outline-none focus:ring-2 focus:ring-primary/20"
        />
      </div>
    </div>

    <nav class="flex-auto space-y-1 overflow-y-auto p-4">
      <button
        *ngFor="let entity of filteredEntities$ | async"
        (click)="onEntitySelect(entity); isMobileMenuOpen = false"
        [class.bg-blue-50]="entities[selectedEntityIndex] === entity"
        [class.text-blue-700]="entities[selectedEntityIndex] === entity"
        class="group flex w-full items-center justify-between rounded-xl px-4 py-3 transition-all hover:bg-gray-100"
      >
        <div class="flex min-w-0 items-center gap-3">
          <mat-icon [class.text-blue-600]="entities[selectedEntityIndex] === entity" class="text-gray-400">folder_shared</mat-icon>
          <span class="truncate whitespace-nowrap text-sm font-medium">{{ getEntityLabel(entity) }}</span>
        </div>
        <div *ngIf="entities[selectedEntityIndex] === entity" class="h-2 w-2 rounded-full bg-blue-600"></div>
      </button>
    </nav>
  </aside>

  <div *ngIf="isMobileMenuOpen" (click)="isMobileMenuOpen = false" class="fixed inset-0 z-40 bg-black/20 md:hidden"></div>

  <main class="flex min-w-0 flex-auto flex-col overflow-hidden">
    
    <header class="z-10 flex flex-col items-start justify-between gap-4 border-b bg-white p-4 shadow-sm md:p-6 lg:flex-row lg:items-center">
      <div class="flex w-full items-center gap-3 lg:w-auto">
        <button mat-icon-button class="-ml-2 md:hidden" (click)="toggleMobileMenu()">
          <mat-icon>menu</mat-icon>
        </button>

        <div class="flex flex-col">
          <div class="mb-1 flex items-center gap-2 text-xs text-gray-400">
            <span>Catálogo Maestro</span>
            <mat-icon class="h-3 w-3 text-[12px]">chevron_right</mat-icon>
            <span class="font-medium text-blue-600">{{ getEntityLabel(entities[selectedEntityIndex]) }}</span>
          </div>
          <h1 class="text-xl font-bold text-gray-800 md:text-2xl">Campos de Usuario</h1>
        </div>
      </div>

      <div class="flex w-full items-center gap-2 md:gap-4 lg:w-auto">
        <div class="flex h-[50px] flex-1 items-center md:min-w-[320px]" [formGroup]="formConfigs[entities[selectedEntityIndex]]">
          <app-toggle-option
            title="Habilitar Configuración"
            icon="settings_suggest"
            formControlName="statusId"
            class="h-full w-full"
          ></app-toggle-option>
        </div>
        <button mat-icon-button (click)="dialogRef.close()" class="shrink-0 border bg-white shadow-sm">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>

    <div class="flex-auto overflow-y-auto bg-gray-50/50 p-4 md:p-8">
      <div class="mx-auto max-w-6xl overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm md:rounded-3xl">
        
        <div class="flex flex-col items-start justify-between gap-4 border-b p-4 md:p-6 xl:flex-row xl:items-center">
          <div>
            <h3 class="font-bold text-gray-700">Listado de Campos</h3>
            <p class="mt-1 text-xs text-gray-500">
              Cantidad máxima permitida: {{ maxFieldsPerEntity }} campos por opción.
            </p>
          </div>
          <div class="flex w-full flex-wrap justify-end gap-2 xl:w-auto">
            <button *canPermissionsOnly="userFieldsConfigPermissions.UPDATE"
              mat-stroked-button
              color="primary"
              class="min-w-0 rounded-xl px-2 py-3 text-xs sm:min-w-[140px] sm:text-sm"
              (click)="manageGroups()"
            >
              <mat-icon>workspaces</mat-icon>
              <span class="sm:hidden">Grupos</span>
              <span class="hidden sm:inline">Gestionar Grupos</span>
            </button>
            <button *canPermissionsOnly="userFieldsConfigPermissions.CREATE"
              mat-flat-button
              color="primary"
              class="min-w-0 rounded-xl px-2 py-3 text-xs sm:min-w-[140px] sm:text-sm"
              (click)="addNewField(entities[selectedEntityIndex])"
              [disabled]="isFieldLimitReached(entities[selectedEntityIndex])"
            >
              <mat-icon>add</mat-icon>
              <span class="sm:hidden">Nuevo</span>
              <span class="hidden sm:inline">Nuevo Campo</span>
            </button>
          </div>
        </div>

        <div class="overflow-x-auto p-0">
          <app-smart-grid [data]="gridData" [columnDefs]="columnDefs" [config]="gridConfig" [loading]="false">
          </app-smart-grid>
        </div>
      </div>
    </div>
  </main>

  <ng-template #addModal>
    <div class="flex h-full flex-col overflow-hidden">
      <div class="flex items-center justify-between border-b bg-white p-6">
        <h2 class="text-xl font-bold tracking-tight">Configuración del Campo</h2>
        <button mat-icon-button (click)="closeEditModal()"><mat-icon>close</mat-icon></button>
      </div>

      <mat-dialog-content class="flex-auto overflow-y-auto bg-gray-50 p-6">
        <ng-container [formGroup]="formConfigs[entities[selectedEntityIndex]]">
          <div formArrayName="fields">
            <div *ngFor="let fieldGroup of getFieldControls(entities[selectedEntityIndex]); let i = index">
              
              <div *ngIf="i === editingFieldIndex" [formGroupName]="i" class="mb-4 flex flex-col gap-6">
                
                <div class="flex items-center justify-between">
                  <span class="rounded-full bg-blue-50 px-4 py-1 text-xs font-bold uppercase text-blue-700">
                    Propiedades del Campo #{{ i + 1 }}
                  </span>
                  <button
                    mat-icon-button
                    color="warn"
                    class="bg-red-50"
                    (click)="deleteField(i)"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>

                <app-form-section
                  title="Información general"
                  icon="storage"
                  iconColor="blue"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
                >
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Código Externo</mat-label>
                    <input matInput formControlName="externalFieldKey" />
                    <mat-hint *ngIf="!fieldGroup.get('externalFieldKey').disabled && !isErpIntegrationActive">Opcional</mat-hint>
                    <mat-error *ngIf="fieldGroup.get('externalFieldKey').hasError('required')">
                      El código externo es requerido cuando la integración ERP está activa
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Nombre Campo (DB)</mat-label>
                    <input
                      matInput
                      formControlName="fieldName"
                      (input)="ufField.sync($event, fieldGroup.get('fieldName'))"
                      (keydown)="ufField.block($event)"
                    />
                    <mat-hint>{{ uf.hint }}</mat-hint>
                    <mat-error *ngIf="fieldGroup.get('fieldName').hasError('required')">El nombre del campo es requerido</mat-error>
                    <mat-error *ngIf="fieldGroup.get('fieldName').hasError('pattern')">{{ uf.hint }}</mat-error>
                    <mat-error *ngIf="fieldGroup.get('fieldName').hasError('duplicateName')">Este nombre ya está en uso</mat-error>
                  </mat-form-field>

                  <div class="flex w-full gap-2">
                    <mat-form-field appearance="outline" class="min-w-0 flex-auto w-full">
                      <mat-label>Tipo de Dato</mat-label>
                      <mat-select formControlName="fieldType">
                        <mat-option *ngFor="let opt of fieldTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="fieldGroup.get('fieldType').hasError('required')">Debe seleccionar un tipo</mat-error>
                    </mat-form-field>
                    <ng-container
                      *ngIf="['select', 'multiselect', 'form', 'attachment'].includes(fieldGroup.get('fieldType').value)"
                    >
                      <button
                        mat-mini-fab
                        color="primary"
                        class="mt-2 shrink-0"
                        [disabled]="isConfigButtonDisabledBySchema(fieldGroup)"
                        [matTooltip]="isConfigButtonDisabledBySchema(fieldGroup) ? 'Los valores se cargan desde el Schema configurado' : ''"
                        (click)="openConfigModal(fieldGroup)"
                      >
                        <mat-icon>settings</mat-icon>
                      </button>
                    </ng-container>
                  </div>
                </app-form-section>

                <app-form-section
                  title="Categorías de uso"
                  icon="label"
                  iconColor="green"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
                >
                  <div formGroupName="fieldLabel" class="contents">
                    <mat-form-field appearance="outline" class="w-full">
                      <mat-label>BackOffice</mat-label>
                      <input matInput formControlName="master" />
                      <mat-error *ngIf="fieldGroup.get('fieldLabel.master').hasError('required')">La etiqueta BackOffice es requerida</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-full">
                      <mat-label>Reporte</mat-label>
                      <input matInput formControlName="report" />
                      <mat-error *ngIf="fieldGroup.get('fieldLabel.report').hasError('required')">La etiqueta Reporte es requerida</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-full">
                      <mat-label>Móvil</mat-label>
                      <input matInput formControlName="mobile" />
                      <mat-error *ngIf="fieldGroup.get('fieldLabel.mobile').hasError('required')">La etiqueta Móvil es requerida</mat-error>
                    </mat-form-field>
                  </div>
                </app-form-section>

                <app-form-section
                  title="Agrupación"
                  icon="workspaces"
                  iconColor="purple"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-10"
                >
                  <mat-form-field appearance="outline" class="w-full sm:col-span-7">
                      <mat-label>Grupo</mat-label>
                      <mat-select formControlName="groupId" (selectionChange)="onGroupSelected(fieldGroup, $event.value)">
                        <mat-option [value]="null">Sin Grupo</mat-option>
                        <mat-option *ngFor="let group of currentGroups" [value]="group._id">
                          <span class="flex items-center gap-2">
                            <mat-icon
                              *ngIf="group.icon"
                              [style.color]="group.iconColor || 'inherit'"
                              class="text-base h-4 w-4 flex items-center justify-center"
                            >
                              {{ group.icon }}
                            </mat-icon>
                            <span>{{ group.name }}</span>
                          </span>
                        </mat-option>
                      </mat-select>
                      <mat-hint>La posición, el ícono y el color se configuran en Gestionar Grupos.</mat-hint>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-full sm:col-span-3">
                    <mat-label>Orden Campo</mat-label>
                    <input matInput type="number" min="1" formControlName="position" />
                    <mat-error *ngIf="fieldGroup.get('position').hasError('required')">
                      La posición es requerida
                    </mat-error>
                    <mat-error *ngIf="fieldGroup.get('position').hasError('min')">
                      La posición debe ser 1 o mayor.
                    </mat-error>
                    <mat-hint *ngIf="getPositionOccupantLabel(fieldGroup) as occupant">
                      Posición ocupada por {{ occupant }}; al guardar se recorrerá el resto.
                    </mat-hint>
                  </mat-form-field>
                </app-form-section>

                <app-form-section
                  title="Condicionales"
                  icon="settings"
                  iconColor="orange"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
                >
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Schema (Master)</mat-label>
                    <input matInput formControlName="schemaMaster" />
                  </mat-form-field>

                  <ng-container [ngSwitch]="fieldGroup.get('fieldType').value">
                      <ng-container *ngSwitchCase="'multiselect'">
                        <mat-form-field *ngIf="!fieldGroup.get('schemaMaster')?.value" appearance="outline" class="w-full">
                          <mat-label>Valores por Defecto (Múltiple)</mat-label>
                          <mat-select formControlName="defaultValue" multiple>
                            <mat-option *ngFor="let opt of fieldGroup.get('valuesData').value" [value]="opt.id">
                              {{ opt.name || opt.label || opt.id }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <app-select-schema
                          *ngIf="fieldGroup.get('schemaMaster')?.value"
                          class="w-full"
                          [schema]="fieldGroup.get('schemaMaster')?.value"
                          [form]="fieldGroup"
                          [isMultiple]="true"
                        >
                        </app-select-schema>
                      </ng-container>

                      <ng-container *ngSwitchCase="'select'">
                        <mat-form-field *ngIf="!fieldGroup.get('schemaMaster')?.value" appearance="outline" class="w-full">
                          <mat-label>Valor por Defecto</mat-label>
                          <mat-select formControlName="defaultValue">
                            <mat-option [value]="''">Ninguno</mat-option>
                            <mat-option *ngFor="let opt of fieldGroup.get('valuesData').value" [value]="opt.id">
                              {{ opt.name || opt.label || opt.id }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <app-select-schema
                          *ngIf="fieldGroup.get('schemaMaster')?.value"
                          class="w-full"
                          [schema]="fieldGroup.get('schemaMaster')?.value"
                          [form]="fieldGroup"
                          [isMultiple]="false"
                        >
                        </app-select-schema>
                      </ng-container>

                      <mat-form-field *ngSwitchDefault appearance="outline" class="w-full">
                        <mat-label>Valor por Defecto</mat-label>
                        <input matInput formControlName="defaultValue" />
                      </mat-form-field>
                  </ng-container>

                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Máx Char</mat-label>
                    <input matInput type="number" formControlName="maxLength" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Mín Char</mat-label>
                    <input matInput type="number" formControlName="minLength" />
                    <mat-error *ngIf="fieldGroup.get('minLength').hasError('minGreaterThanMax')">
                      El mínimo no puede ser mayor que el máximo.
                    </mat-error>
                  </mat-form-field>

                   <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Campo Padre</mat-label>
                    <input matInput formControlName="parentFieldName" />
                  </mat-form-field>


                  <mat-form-field *ngIf="fieldGroup.get('fieldType').value === 'text'" appearance="outline" class="w-full">
                    <mat-label>Conversión de texto</mat-label>
                    <mat-select formControlName="caseConversion">
                      <mat-option value="NONE">Ninguno</mat-option>
                      <mat-option value="UPPER">Mayúsculas</mat-option>
                      <mat-option value="LOWER">Minúsculas</mat-option>
                      <mat-option value="TITLE">Capitalizar palabras</mat-option>
                      <mat-option value="SENTENCE">Capitalizar primera</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="fieldGroup.get('fieldType').value === 'text'" appearance="outline" class="w-full">
                    <mat-label>Máscara de Texto</mat-label>
                    <input matInput formControlName="mask" placeholder="Ej. (000) 000-000" />
                  </mat-form-field>
                </app-form-section>

                <app-form-section
                  title="Configuración"
                  icon="settings"
                  iconColor="indigo"
                  contentClass="grid grid-cols-1 gap-4 sm:grid-cols-2"
                >
                  <app-toggle-option title="Visible" icon="visibility" iconColor="blue" formControlName="isVisible"></app-toggle-option>
                  <app-toggle-option title="Requerido" icon="lock" iconColor="orange" formControlName="isRequired"></app-toggle-option>
                  <app-toggle-option title="Fijo/Mandatorio" icon="gavel" iconColor="red" formControlName="isTypeMandatory"></app-toggle-option>
                  <app-toggle-option *ngIf="fieldGroup.get('fieldType').value === 'text'" title="Eliminar espacios" icon="content_cut" iconColor="green" formControlName="trimSpaces"></app-toggle-option>
                </app-form-section>
              </div>
            </div>
          </div>
        </ng-container>
      </mat-dialog-content>

      <div class="flex justify-end gap-3 border-t bg-white p-4">
        <button mat-button (click)="closeEditModal()">Cancelar</button>
        <button
          mat-flat-button
          class="rounded-xl px-6 py-2 bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
          (click)="confirmFieldEdit()"
          [disabled]="
            getFieldControls(entities[selectedEntityIndex])[editingFieldIndex]?.invalid
            || isSavingCatalogForSelectedEntity"
        >
          {{ isSavingCatalogForSelectedEntity ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </ng-template>

</div>
